module.exports = __webpack_public_path__ + "img/friend.ea51bb33.png";